import React, { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getCarrier, updateCarrier } from '../../../../redux/profile/carrierInformationActions'
import { carrierInformationSelector } from '../../../../redux/profile/carrierInformationSelector'
import CarrierInformationForm from '../CarrierInformationForm'
import { Spinner } from '../../../../components'

const CarrierInformation = () => {
  const { load, error, carrier, loadUpdate } = useSelector(carrierInformationSelector)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getCarrier())
  }, [dispatch])

  const editCarrier = useCallback(_carrier => {
    dispatch(updateCarrier(_carrier))
  }, [dispatch])

  return (

    load ? (<Spinner />) : (
      <CarrierInformationForm
        load={loadUpdate}
        error={error}
        carrier={carrier}
        onSubmit={editCarrier}
      />
    )

  )
}

export default CarrierInformation
